import { IProductTemplate } from 'modules/inventory/settings/product-templates/interfaces';

// `order` is not edited by hand: it is the position in the list, assigned on save.
export const withOrder = (template: IProductTemplate): IProductTemplate => ({
  ...template,
  fields: (template.fields ?? []).map((field, index) => ({ ...field, order: index })),
});

export const sortByOrder = (template: IProductTemplate): IProductTemplate => ({
  ...template,
  fields: [...(template.fields ?? [])].sort((a, b) => (a.order ?? 0) - (b.order ?? 0)),
});
